import { generateParams } from 'features/filters/filtersSlice';

import { get, post } from 'utils/api/api';

import { CommentsList, CreateComment } from 'types/comments';
import { SortOrders } from 'types/filters';

import { COMMENT, COMMENTS } from 'constants/endpoints';
import { MAX_ITEMS_TO_GET } from 'constants/uiSettings';

class CommentsService {
  async getComments({
    id,
    isLastOnly = false
  }: {
    id: string;
    isLastOnly?: boolean;
  }): Promise<CommentsList> {
    let params = '';

    params = generateParams({
      page: 0,
      pageSize: isLastOnly ? 1 : MAX_ITEMS_TO_GET,
      order: isLastOnly ? SortOrders.Desc : SortOrders.Asc
    });

    const response = await get(`${COMMENTS}/${id}${params}`);
    return response;
  }

  async createComment(payload: CreateComment): Promise<Comment> {
    const response = await post(COMMENT, payload);
    return response;
  }
}

export default new CommentsService();
